module.exports = __webpack_public_path__ + "static/media/costPrice.59c66a12.mp3";